import { html, TemplateResult, CSSResultGroup } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { OutlineElement } from '../../base/outline-element/outline-element';
import componentStyles from './idblab-cta-banner.css.lit';
import { SlotController } from '../../controllers/slot-controller';
import '../../base/outline-container/outline-container';

/**
 * The CTA Banner component.
 * @element idblab-cta-banner
 * @property title-weight - Sets the title bold etc.
 * @slot background - Background image
 * @slot content - Main content
 * @slot cta - Call to actions
 */

export type FontWeights = 'normal' | 'semibold' | 'bold';
@customElement('idblab-cta-banner')
export class IdblabCtaBanner extends OutlineElement {
  slots = new SlotController(
    this, // This, the host element.
    true // To shift or not to shift LightDom nodes to ShadowDOM.
  );
  static styles: CSSResultGroup = [componentStyles];

  /**
   * Let's you set the title weight.
   */
  @property({ attribute: 'title-weight' })
  fontWeight: FontWeights;

  render(): TemplateResult {
    return html`
      <outline-container x-padding>
        <div class="wrapper">
          <div class="image-slot-wrapper">
            <slot name="background"></slot>
          </div>
          <div class="content">
           <idb-heading level="h2" level-style="${this.fontWeight}" level-size="2xl">
            <slot name="content"></slot>
           </idb-heading>
           <slot name="cta"></slot>
          </div>
        </div>
      </outline-container>
    `;
  }
}
